import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ConfigService } from '../../../Core/Config/services/config.service';
import { CurrentUserStateService } from '../../../Core/Users/services/current-user-state.service';


@Component({
    selector: 'agpr-distribution-plan',
    templateUrl: './distribution-plan.component.html',
    styleUrls: ['./distribution-plan.component.scss'],
    standalone: false
})
export class DistributionPlanComponent implements OnInit, OnDestroy {

    readonly agilityPricing = {
        headers: ['USD', 'CAD', 'GBP', 'EUR'],
        rows: [
            ['5,000', '$180', '$230', '£130', '€150'],
            ['25,000', '$600', '$800', '£400', '€500'],
            ['50,000', '$1,020', '$1,300', '£700', '€800']
        ]
    };

    readonly burrellesPricing = {
        headers: ['USD'],
        rows: [
            ['5,000', '$199'],
            ['25,000', '$599'],
            ['50,000', '$999']
        ]
    };

    readonly uniceptaPricing = {
        headers: ['EUR'],
        rows: [
            ['5,000', '€275'],
            ['25,000', '€750'],
            ['45,000', '€1,290']
        ]
    };

    pricing = this.agilityPricing;
    includeOutreach: boolean = true;

    loading: boolean = false;
    subscriptions: Subscription[] = [];

    constructor(
        private configService: ConfigService,
        private currentUserStateService: CurrentUserStateService
    ) {
        this.setPricing();
        this.loading = true;
    }

    ngOnInit(): void {
        this.subscriptions.push(
            this.currentUserStateService.getUILanguageTag().subscribe(x => {
                if (!!x) {
                    this.loading = false;
                }
            })
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }

    private setPricing() {
        this.pricing = this.agilityPricing;
        this.includeOutreach = true;

        if (this.configService.brandGUIDIsBurrelles()) {
            this.pricing = this.burrellesPricing;
            this.includeOutreach = false;
        }

        if (this.configService.brandGUIDIsUnicepta()) {
            this.pricing = this.uniceptaPricing;
            this.includeOutreach = false;
        }
    }
}
